import installBaseComponents from "./components/installBaseComponents.js";
import installGlobalComponentsVite from "./components/installGlobalComponentsVite";

export default {
    install(Vue, options) {
        // Components
        if (options && options.installAll === true) {
            installBaseComponents(); // to get the extras
            installGlobalComponentsVite(); // Get the rest with vite.
        } else {
            installBaseComponents();
        }
    },
};
